import styled from 'styled-components/macro'

export const PastChatsHistory = styled.div`
  display: flex;
  gap: 20px;
  padding: var(--third-paddind);
`
